module.exports = __webpack_public_path__ + "img/empty.4d4bc81c.png";